import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import Login from "../components/Login.tsx";

// Simple RFC-ish email check — just enough to avoid sending junk to Firebase.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface LoginSearch {
  email?: string;
  source?: string;
  autosend?: boolean;
  mode?: "login" | "signup";
}

const LoginPage: React.FC = () => {
  const { email, source, autosend, mode } = Route.useSearch();

  // No redirect logic here - all navigation is handled by __root.tsx
  // This avoids race conditions and keeps routing logic centralized

  return (
    <Login
      initialEmail={email}
      source={source}
      autosend={autosend}
      initialMode={mode}
    />
  );
};

export const Route = createFileRoute("/login")({
  component: LoginPage,
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    const rawEmail =
      typeof search.email === "string" ? search.email.trim() : undefined;
    const email = rawEmail && EMAIL_REGEX.test(rawEmail) ? rawEmail : undefined;
    const source =
      typeof search.source === "string" ? search.source : undefined;
    const autosend =
      search.autosend === true || search.autosend === "true" ? true : undefined;
    const mode =
      search.mode === "login" || search.mode === "signup"
        ? search.mode
        : undefined;
    return { email, source, autosend, mode };
  },
});
